export enum STREAM_STATUS {
  RUNNING = 'running',
  DONE = 'done',
  ERROR = 'error',
  STATIC = 'static',
  IDLE = 'idle',
}
